import React from 'react';
import { Formik, FormikHelpers } from 'formik'; // Import FormikHelpers
import { string, object } from 'yup';
import { MetaField } from '../../../store/models/cycles';
import { FieldInput } from '../../FieldInput/FieldInput';

interface NewFieldFormProps {
  onAdd: (field: MetaField) => Promise<void>;
  isLoading: boolean;
  range: { min: number, max: number }
}

const NewFieldForm: React.FC<NewFieldFormProps> = ({ onAdd, isLoading, range }) => {
  const validationSchema = object({
    key: string()
      .required('Key is required')
      .min(range.min, `Key must be at least ${range.min} characters`)
      .max(range.max, `Key must be max ${range.max} characters`),
    value: string()
      .required('Value is required')
      .min(range.min, `Value must be at least ${range.min} characters`)
      .max(range.max, `Value must be max ${range.max} characters`),
  });

  return (
    <div className="mt-7.5">
      <h3 className="mb-4 text-lg font-medium text-black dark:text-white">Add New Field</h3>
      <Formik
        initialValues={{ key: '', value: '' }}
        validationSchema={validationSchema}
        onSubmit={async (values, { resetForm }: FormikHelpers<{ key: string, value: string }>) => {
          await onAdd({ key: values.key.trim(), value: values.value.trim() });
          resetForm();
        }}
      >
        {({ values, setFieldValue, setFieldTouched, errors, touched, handleSubmit }) => (
          <div>
            <FieldInput
              field={values}
              onUpdate={(updatedField) => {
                setFieldValue('key', updatedField.key);
                setFieldValue('value', updatedField.value);

                if (updatedField?.key && !touched?.key) {
                  setFieldTouched('key', true);
                }

                if (updatedField?.value && !touched?.value) {
                  setFieldTouched('value', true);
                }
              }}
              keyError={(touched?.key && errors?.key) ? errors.key : ''}
              valueError={(touched?.value && errors?.value) ? errors.value : ''}
            />
            <button
              type="button"
              onClick={() => handleSubmit()}
              disabled={isLoading || Boolean(errors?.key || errors?.value)}
              className="inline-flex items-center justify-center rounded-md bg-secondary px-6 py-2 mt-4 text-white hover:bg-opacity-90 disabled:opacity-50"
            >
              {isLoading ? 'Adding...' : 'Add'}
            </button>
          </div>
        )}
      </Formik>
    </div>
  );
};

export default NewFieldForm;